import React, { useState } from "react";

const LogoUploader = ({ onLogoChange }) => {
  const [logoPreview, setLogoPreview] = useState(null);

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoPreview(reader.result);
        onLogoChange(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeLogo = () => {
    setLogoPreview(null);
    onLogoChange(null);
  };

  return (
    <div className="space-y-2">
      <label className="block text-xs sm:text-sm font-semibold text-slate-500">Logo (Optional)</label>
      <div className="flex items-center gap-3 sm:gap-4">
        <label className="flex-1 cursor-pointer group">
          <div className="flex items-center gap-3 px-4 py-3 sm:py-3.5 border-2 border-dashed border-slate-200 group-hover:border-blue-400 group-hover:bg-blue-50/50 transition-all duration-200" style={{ borderRadius: 'var(--radius-input)' }}>
            <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-slate-100 group-hover:bg-blue-100 flex items-center justify-center text-slate-400 group-hover:text-blue-600 transition-colors flex-shrink-0">
              <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <div className="min-w-0">
              <p className="text-sm font-bold text-slate-700 truncate">Upload Image</p>
              <p className="text-[10px] text-slate-400 font-medium uppercase tracking-tight">JPG, PNG or SVG</p>
            </div>
          </div>
          <input
            type="file"
            accept="image/*"
            onChange={handleLogoUpload}
            className="hidden"
          />
        </label>

        {logoPreview && (
          <div className="relative group flex-shrink-0">
            <img
              src={logoPreview}
              alt="Logo Preview"
              className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl object-contain bg-white border border-slate-200 p-1 shadow-sm"
            />
            <button
              onClick={removeLogo}
              className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-red-500 text-white flex items-center justify-center shadow-lg hover:bg-red-600 transition-colors opacity-0 group-hover:opacity-100 text-sm font-bold"
            >
              &times;
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LogoUploader;
